/**
 * * end of cart upsell block part
 */
document.addEventListener("DOMContentLoaded", function () {
  const amountFreeProduct = document.querySelector("[data-treshold-product]")
    ? document.querySelector("[data-treshold-product]").getAttribute("data-treshold-product")
    : null;

  var cartTotalEl = document.querySelector(".gb-totals-total-value");
  var cart_total = cartTotalEl ? (cartTotalEl.textContent || "").trim() : "";
  if (amountFreeProduct > 0 && show_progress_bar) {
    const hasPremiumKit = document.querySelector(".premium-attachment-kit") !== null;
    if (hasPremiumKit) {
      console.log("Premium kit detected - skipping auto free gift trigger");
    } else {
      setTimeout(function () {
        var el = document.querySelector(".gb-totals-total-value");
        var cart_total = el ? (el.textContent || "").trim() : "";
        if (cart_total >= amountFreeProduct) {
          if (document.querySelector(".cart-item.gb-find-remove-product")) {
            console.log("Free product already in cart");
          } else {
            console.log("Adding free product");
            var trigger = document.querySelector(".gb-free-product-trigger");
            if (trigger) trigger.click();
          }
        } else {
          console.log("Removing free product - under threshold");
          var removeBtn = document.querySelector(".gb-remove-product");
          if (removeBtn) removeBtn.click();
        }
      }, 3000);

      document.body.addEventListener("click", function (e) {
        if (!e.target.closest(".gb-sumbit-free")) return;
        setTimeout(function () {
          var el = document.querySelector(".gb-totals-total-value");
          var cart_total = el ? (el.textContent || "").trim() : "";
          if (cart_total >= amountFreeProduct) {
            if (!document.querySelector(".cart-item.gb-find-remove-product")) {
              var trigger = document.querySelector(".gb-free-product-trigger");
              if (trigger) trigger.click();
            }
          } else {
            var removeBtn = document.querySelector(".gb-remove-product");
            if (removeBtn) removeBtn.click();
          }
        }, 3000);
      });
    }
  }

  document.body.addEventListener("change", async function (e) {
    const input = e.target.closest?.(".gb-shipping-protection-button input[type='checkbox']");
    if (!input) return;
    const shouldAdd = input.checked;
    const form = document.querySelector("form.shipping-protection-form");
    const variantId = form?.querySelector('[name="id"]')?.value;
    if (!form || !variantId) {
      input.checked = !shouldAdd;
      return;
    }

    await window.fourPawCartWork?.settled;
    const finish = window.fourPawCartWork?.begin();
    if (window.fourPawCartWork && !finish) {
      input.checked = !shouldAdd;
      return;
    }

    try {
      const request = window.fourPawCartFetch || window.fetch.bind(window);
      let data;
      if (shouldAdd) {
        const formData = new FormData(form);
        formData.append("sections", "cart-drawer,cart-icon-bubble");
        formData.append("sections_url", window.location.pathname);
        const response = await request(routes.cart_add_url, {
          method: "POST",
          body: formData,
          headers: { Accept: "application/json", "X-Requested-With": "XMLHttpRequest" },
        });
        data = await response.json();
        if (!response.ok || data.status) throw new Error(data.description || "Unable to add shipping protection.");
      } else {
        let lineKey = String(input.dataset.lineKey || "");
        if (!lineKey) {
          const cartResponse = await request(`${routes.cart_url}.js`, { cache: "no-store" });
          const cart = await cartResponse.json();
          if (!cartResponse.ok) throw new Error("Unable to read the cart.");
          lineKey = String(
            cart.items.find((item) => String(item.variant_id) === String(variantId))?.key || "",
          );
        }
        if (!lineKey) return;
        const response = await request(`${routes.cart_change_url}.js`, {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "X-Requested-With": "XMLHttpRequest",
          },
          body: JSON.stringify({
            id: lineKey,
            quantity: 0,
            sections: ["cart-drawer", "cart-icon-bubble"],
            sections_url: window.location.pathname,
          }),
        });
        data = await response.json();
        if (!response.ok || data.status) throw new Error(data.description || "Unable to remove shipping protection.");
      }

      const drawer = document.querySelector("cart-drawer");
      if (drawer?.renderContents && data.sections?.["cart-drawer"]) {
        drawer.renderContents(data, false, true);
      }
      const controller = drawer?.querySelector("cart-drawer-items") || document.querySelector("cart-items");
      if (controller?.normalizeFourPawSafeWalkCart) {
        const isFullCart = Number.isFinite(Number(data.item_count)) && Number.isFinite(Number(data.total_price));
        const normalized = await controller.normalizeFourPawSafeWalkCart(isFullCart ? data : null);
        await controller.fourPawRefreshCart(normalized.cart, true);
      }
    } catch (error) {
      window.fourPawCartWork?.fail();
      if (input.isConnected) input.checked = !shouldAdd;
      console.error("Error updating shipping protection:", error);
    } finally {
      finish?.();
    }
  });

  document.body.addEventListener("change", function (e) {
    var select = e.target.closest && e.target.closest(".gb-change-variant_id");
    if (!select) return;
    var opt = select.options[select.selectedIndex];
    var id_change = opt ? opt.getAttribute("data-variant-id") : null;
    if (!id_change) {
      console.error("No data-variant-id found on selected option");
      return;
    }
    var block = select.closest(".gb-get-main-freq-pro");
    var input = block ? block.querySelector(".product-variant-id") : null;
    if (input) input.value = id_change;
  });
});

document.addEventListener("change", function (e) {
  if (e.target.matches(".cart-drawer .gbfrequently-bought-with-main-whole .select__select")) {
    const parentBlock = e.target.closest(".gb-get-main-freq-pro");
    if (!parentBlock) {
      console.log("Error: Could not find parent block");
      return;
    }

    const allValues = Array.from(parentBlock.querySelectorAll(".select__select"))
      .map((sel) => sel.value)
      .join(" / ");

    const variantSelect = parentBlock.querySelector('[name="variants"]');
    if (!variantSelect) {
      console.log("Error: Could not find variant selector");
      return;
    }

    const matchedOption = Array.from(variantSelect.options).find((option) => option.text.includes(allValues));

    const idInput = parentBlock.querySelector('[name="id"]');
    if (!idInput) {
      console.log("Error: Could not find id input field");
      return;
    }

    if (matchedOption) {
      console.log("Matched variant option value:", matchedOption.value);
      idInput.value = matchedOption.value;
      console.log("Set ID input value to:", idInput.value);
    } else {
      console.log("No matching variant found for:", allValues);
    }
  }
});

// Add validation for form submissions: require id when in single-variant mode; skip when form has items[] (bundles / premium kit)
document.addEventListener("submit", function (e) {
  if (typeof Elixir_ProductFormExists !== 'function' || !Elixir_ProductFormExists()) return;
  if (typeof Elixir_GetProductForm !== 'function' || Elixir_GetProductForm() !== e.target) return;
  if (typeof Elixir_GetProductFormVariantId !== 'function') return;
  if (typeof Elixir_ProductFormHasItemsInputs === 'function' && Elixir_ProductFormHasItemsInputs()) return;
  const variantId = Elixir_GetProductFormVariantId();
  if (!variantId) {
    console.log("Preventing submission - missing id parameter (single-product form has no variant id)");
    e.preventDefault();
    if (window.ThemeEditorToast && typeof window.ThemeEditorToast.show === 'function') {
      window.ThemeEditorToast.show('Add to cart failed: missing variant ID on product form.', { type: 'error', duration: 5000 });
    }
    return false;
  }
});

document.addEventListener("DOMContentLoaded", function () {
  document.addEventListener("keydown", function (e) {
    var input =
      (e.target.matches && e.target.matches(".quantity__input")
        ? e.target
        : e.target.closest && e.target.closest(".quantity__input")) || null;
    if (!input) return;
    if (e.key === "Enter" || e.keyCode === 13) {
      e.preventDefault();
      input.blur();
    }
  });
});

document.addEventListener("DOMContentLoaded", function () {
  document.body.addEventListener("click", function (e) {
    var btn =
      e.target.closest(".gbfrequently-bought-with-main-whole button") ||
      e.target.closest(".gbfrequently-bought-with-main-whole .gb-sumbit-free") ||
      e.target.closest(".gb-free-product-trigger") ||
      e.target.closest(".gb-product-shipping-protection-product-tirgger") ||
      e.target.closest(".gb-product-sticky-add-to-cart-form");
    if (!btn) return;
    var parentBlock = btn.closest(".gb-get-main-freq-pro") || btn.closest("form");
    if (!parentBlock) {
      console.error("Could not find parent block for frequently bought product");
      return;
    }
    var productId = null;
    var idInput = parentBlock.querySelector('input[name="id"]');
    if (idInput && idInput.value) {
      productId = idInput.value;
    } else if (parentBlock.querySelector(".gb-change-variant_id")) {
      var select = parentBlock.querySelector(".gb-change-variant_id");
      var opt = select && select.options[select.selectedIndex];
      if (opt) {
        productId = opt.getAttribute("data-variant-id");
      }
    } else if (parentBlock.querySelector(".product-variant-id")) {
      var variantInput = parentBlock.querySelector(".product-variant-id");
      productId = variantInput ? variantInput.value : null;
    } else if (btn.getAttribute("data-variant-id")) {
      productId = btn.getAttribute("data-variant-id");
    }
    console.log("Frequently bought product add to cart - ID:", productId);
    if (btn.classList.contains("gb-free-product-trigger") && !show_progress_bar) return;
    if (!productId) {
      console.error("Missing product ID for frequently bought product");
      e.preventDefault();
      return false;
    }
    if (!idInput) {
      console.log("Adding missing ID input to frequently bought product form");
      var newIdInput = document.createElement("input");
      newIdInput.type = "hidden";
      newIdInput.name = "id";
      newIdInput.value = productId;
      parentBlock.appendChild(newIdInput);
    } else {
      idInput.value = productId;
    }
    var quantityInput = parentBlock.querySelector('input[name="quantity"]');
    if (!quantityInput) {
      console.log("Adding default quantity input to frequently bought product form");
      var newQtyInput = document.createElement("input");
      newQtyInput.type = "hidden";
      newQtyInput.name = "quantity";
      newQtyInput.value = "1";
      parentBlock.appendChild(newQtyInput);
    } else if (!quantityInput.value || parseFloat(quantityInput.value, 10) < 1) {
      quantityInput.value = "1";
    }
  });
});

// Kaching showing Price(Compare Price) Text in ATC fix

const KachingApp = () => {
  const isProductPage = document.querySelector('.shopify-section.shop-product-section');
  if (!isProductPage) return;

  let buttonObserver = null;

  const createElement = (tag, cls, content) => {
    const el = document.createElement(tag);
    el.classList.add(...cls.split(' '));
    el.textContent = content;
    return el;
  };

  const updateAddToCartButton = (bundle) => {
    const addToCartButton = document.querySelector('.shop-add-to-cart-button');
    if (!addToCartButton || !bundle) return;

    const buttonTextEl = addToCartButton.querySelector('.button-text');
    if (!buttonTextEl) return;

    const persistentText = addToCartButton.getAttribute('data-persistent-text') || 'Add to cart';
    if (addToCartButton.dataset.showPrice === 'false') {
      buttonTextEl.textContent = persistentText;
      delete addToCartButton.dataset.currentBundlePrice;
      delete addToCartButton.dataset.currentBundleComparePrice;
      return;
    }

    const bundlePriceEl = bundle.querySelector('.kaching-bundles__bar-price');
    const bundleComparePriceEl = bundle.querySelector('.kaching-bundles__bar-full-price');

    if (bundlePriceEl) {
      const price = bundlePriceEl.textContent.trim();
      const comparePrice = bundleComparePriceEl ? bundleComparePriceEl.textContent.trim() : '';

      // Update button text with actual values
      if (comparePrice) {
        buttonTextEl.innerHTML = `${persistentText} - ${price}<span class="compare-price">(${comparePrice})</span>`;
      } else {
        buttonTextEl.innerHTML = `${persistentText} - ${price}`;
      }

      // Store current bundle reference for observer
      addToCartButton.dataset.currentBundlePrice = price;
      addToCartButton.dataset.currentBundleComparePrice = comparePrice || '';
    }
  };

  const forceUpdateButton = () => {
    const addToCartButton = document.querySelector('.shop-add-to-cart-button');
    const buttonTextEl = addToCartButton?.querySelector('.button-text');
    
    if (!buttonTextEl) return;

    const price = addToCartButton.dataset.currentBundlePrice;
    const comparePrice = addToCartButton.dataset.currentBundleComparePrice;
    const persistentText = addToCartButton.getAttribute('data-persistent-text') || 'Add to cart';

    if (addToCartButton.dataset.showPrice === 'false') {
      buttonTextEl.textContent = persistentText;
      return;
    }

    // Check if button shows placeholders
    if (buttonTextEl.textContent.includes('[price]') || buttonTextEl.textContent.includes('[comparePrice]')) {
      if (price) {
        if (comparePrice) {
          buttonTextEl.innerHTML = `${persistentText} - ${price}<span class="compare-price">(${comparePrice})</span>`;
        } else {
          buttonTextEl.innerHTML = `${persistentText} - ${price}`;
        }
      }
    }
  };

  const setupButtonObserver = () => {
    const addToCartButton = document.querySelector('.shop-add-to-cart-button');
    if (!addToCartButton) return;

    // Disconnect existing observer if any
    if (buttonObserver) {
      buttonObserver.disconnect();
    }

    // Create new observer to watch for button text changes
    buttonObserver = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'childList' || mutation.type === 'characterData') {
          // Use setTimeout to let the other script finish, then override
          setTimeout(forceUpdateButton, 0);
        }
      });
    });

    // Observe the button and its children for any changes
    buttonObserver.observe(addToCartButton, {
      childList: true,
      subtree: true,
      characterData: true,
      characterDataOldValue: true
    });
  };

  const updatePriceBlock = (bundle) => {
    const priceBlock = document.querySelector('.shop-product-price-container');
    if (!priceBlock || !bundle) return;

    const priceEl = priceBlock.querySelector('.shop-product-price-block');
    const comparePriceEl = priceBlock.querySelector('.shop-compare-price');

    const bundlePriceEl = bundle.querySelector('.kaching-bundles__bar-price');
    const bundleComparePriceEl = bundle.querySelector('.kaching-bundles__bar-full-price');

    if (priceEl && bundlePriceEl) priceEl.textContent = bundlePriceEl.textContent;

    if (bundleComparePriceEl) {
      if (comparePriceEl) {
        comparePriceEl.textContent = bundleComparePriceEl.textContent;
      } else {
        priceBlock.appendChild(
          createElement('span', 'shop-compare-price', bundleComparePriceEl.textContent)
        );
      }
    }
  };

  const updateAllPrices = (bundle) => {
    updatePriceBlock(bundle);
    updateAddToCartButton(bundle);
    
    // Force update again after a short delay to override any competing scripts
    setTimeout(() => forceUpdateButton(), 50);
    setTimeout(() => forceUpdateButton(), 200);
  };

  const initApp = (app) => {
    const applyFirstCheckedBundle = () => {
      const selectedBundle = app.querySelector('.kaching-bundles__bar:has(input:checked)');
      if (selectedBundle) {
        updateAllPrices(selectedBundle);
      }
    };

    const initAppFunctions = () => {
      const connectSelectedBundle = () => {
        const selectedBundle = app.querySelector('.kaching-bundles__bar:has(input:checked)');
        if (selectedBundle) {
          updateAllPrices(selectedBundle);
          setupButtonObserver();
          return true;
        }
        return false;
      };

      if (connectSelectedBundle()) return;

      const bundleObserver = new MutationObserver(() => {
        if (!connectSelectedBundle()) return;
        bundleObserver.disconnect();
      });
      bundleObserver.observe(app, { childList: true, subtree: true, attributes: true });
      setTimeout(() => bundleObserver.disconnect(), 5000);
    };

    app.addEventListener('change', () => {
      const selectedBundle = app.querySelector('.kaching-bundles__bar:has(input:checked)');
      updateAllPrices(selectedBundle);
    });

    applyFirstCheckedBundle();
    initAppFunctions();
  };

  const initializeApp = (app) => {
    if (!app || app.dataset.fourpawKachingInitialized === 'true') return;
    app.dataset.fourpawKachingInitialized = 'true';
    initApp(app);
  };

  const existingApp = document.querySelector('kaching-bundle');
  if (existingApp) {
    initializeApp(existingApp);
    return;
  }

  if (!window.customElements || typeof window.customElements.whenDefined !== 'function') return;

  window.customElements.whenDefined('kaching-bundle').then(() => {
    const registeredApp = document.querySelector('kaching-bundle');
    if (registeredApp) {
      initializeApp(registeredApp);
      return;
    }

    const appObserver = new MutationObserver(() => {
      const app = document.querySelector('kaching-bundle');
      if (!app) return;
      appObserver.disconnect();
      initializeApp(app);
    });
    appObserver.observe(document.body, { childList: true, subtree: true });
    setTimeout(() => appObserver.disconnect(), 5000);
  });
};

window.addEventListener('DOMContentLoaded', KachingApp);

(() => {
  const scrollToSafeWalkSize = () => {
    const sizePicker = document.querySelector('.simple-variant-picker__option.option--size');
    if (!sizePicker) return false;

    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const desktopLayout = window.matchMedia('(min-width: 990px)').matches;
    const viewportOffset = desktopLayout ? 150 : Math.min(140, Math.max(100, window.innerHeight * 0.14));
    const documentTop = window.scrollY + sizePicker.getBoundingClientRect().top;
    window.scrollTo({
      top: Math.max(0, documentTop - viewportOffset),
      behavior: reduceMotion ? 'auto' : 'smooth'
    });
    window.setTimeout(() => {
      const currentTop = sizePicker.getBoundingClientRect().top;
      if (currentTop < viewportOffset - 30 || currentTop > window.innerHeight * 0.72) {
        window.scrollBy({
          top: currentTop - viewportOffset,
          behavior: reduceMotion ? 'auto' : 'smooth'
        });
      }
    }, reduceMotion ? 0 : 420);
    window.setTimeout(() => {
      const currentTop = sizePicker.getBoundingClientRect().top;
      if (currentTop < viewportOffset - 30 || currentTop > window.innerHeight * 0.72) {
        window.scrollBy({ top: currentTop - viewportOffset, behavior: 'auto' });
      }
      const focusTarget = sizePicker.querySelector('.simple-variant-picker__radio:checked:not(:disabled)')
        || sizePicker.querySelector('.simple-variant-picker__radio:not(:disabled)');
      focusTarget?.focus({ preventScroll: true });
    }, reduceMotion ? 0 : 900);
    return true;
  };

  window.FourPawScrollToSize = scrollToSafeWalkSize;
  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-fourpaw-scroll-to-size]');
    if (!trigger) return;
    event.preventDefault();
    scrollToSafeWalkSize();
  });
})();
